"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc721Transfers = exports.Erc20Transfers = exports.UserOp = void 0;
const token_1 = require("../token");
/**
 * Represents a user operation.
 */
class UserOp {
    /**
     * Creates a new instance of the UserOp class.
     * @param transactionHash The transaction hash.
     * @param userOpHash The user operation hash.
     * @param sender The sender address.
     * @param entryPoint The entry point.
     * @param paymaster The paymaster address.
     * @param paymasterAndData The paymaster and data.
     * @param nonce The nonce.
     * @param success Indicates if the operation was successful.
     * @param revertReason The revert reason, if any.
     * @param blockTime The block time.
     * @param blockNumber The block number.
     * @param target The target address.
     * @param beneficiary The beneficiary address.
     * @param erc20Transfers The ERC20 transfers.
     * @param erc721Transfers The ERC721 transfers.
     */
    constructor(transactionHash, userOpHash, sender, entryPoint, paymaster, paymasterAndData, nonce, success, revertReason, blockTime, blockNumber, target, beneficiary, erc20Transfers = [], erc721Transfers = []) {
        this.transactionHash = transactionHash;
        this.userOpHash = userOpHash;
        this.sender = sender;
        this.entryPoint = entryPoint;
        this.paymaster = paymaster;
        this.paymasterAndData = paymasterAndData;
        this.nonce = nonce;
        this.success = success;
        this.revertReason = revertReason;
        this.blockTime = blockTime;
        this.blockNumber = blockNumber;
        this.target = target;
        this.beneficiary = beneficiary;
        this.erc20Transfers = erc20Transfers;
        this.erc721Transfers = erc721Transfers;
    }
    /**
     * Creates a new instance of the UserOp class from a JSON object.
     * @param json The JSON object.
     * @returns A new instance of the UserOp class.
     */
    static fromJson(json) {
        var _a, _b, _c, _d, _e;
        return new UserOp(json.transactionHash, json.userOpHash, json.sender, json.entryPoint, json.paymaster, json.paymasterAndData, json.nonce, json.success, (_a = json.revertReason) !== null && _a !== void 0 ? _a : null, json.blockTime, json.blockNumber, json.target, json.beneficiary, (_c = (_b = json.erc20Transfers) === null || _b === void 0 ? void 0 : _b.map(Erc20Transfers.fromJson)) !== null && _c !== void 0 ? _c : [], (_e = (_d = json.erc721Transfers) === null || _d === void 0 ? void 0 : _d.map(Erc721Transfers.fromJson)) !== null && _e !== void 0 ? _e : []);
    }
    /**
     * Creates an array of UserOp instances from an array of JSON objects.
     * @param docs The array of JSON objects.
     * @returns An array of UserOp instances.
     */
    static opsFromJson(docs) {
        return docs.map(doc => UserOp.fromJson(doc));
    }
}
exports.UserOp = UserOp;
/**
 * Represents an ERC20 transfer.
 */
class Erc20Transfers {
    /**
     * Represents a user operation.
     * @constructor
     * @param from - The sender address.
     * @param to - The recipient address.
     * @param value - The value of the operation.
     * @param contractAddress - The address of the contract.
     * @param name - The name of the operation.
     * @param symbol - The symbol of the operation.
     * @param decimals - The number of decimal places for the operation.
     */
    constructor(from, to, value, contractAddress, name, symbol, decimals) {
        this.from = from;
        this.to = to;
        this.value = value;
        this.contractAddress = contractAddress;
        this.name = name;
        this.symbol = symbol;
        this.decimals = decimals;
    }
    /**
     * Creates an instance of Erc20Transfers from a JSON object.
     * @param json The JSON object representing the ERC20 transfer.
     * @returns An instance of Erc20Transfers.
     */
    static fromJson(json) {
        return new Erc20Transfers(json.from, json.to, (0, token_1.amountFromJson)(json.value), json.contractAddress, json.name, json.symbol, json.decimals);
    }
}
exports.Erc20Transfers = Erc20Transfers;
/**
 * Represents a transfer of an ERC721 token.
 */
class Erc721Transfers {
    /**
     * Creates a new instance of the Erc721Transfers class.
     * @param from The address of the sender.
     * @param to The address of the recipient.
     * @param contractAddress The address of the ERC721 contract.
     * @param tokenId The ID of the token being transferred.
     * @param name The name of the ERC721 contract.
     * @param symbol The symbol of the ERC721 contract.
     */
    constructor(from, to, contractAddress, tokenId, name, symbol) {
        this.from = from;
        this.to = to;
        this.contractAddress = contractAddress;
        this.tokenId = tokenId;
        this.name = name;
        this.symbol = symbol;
    }
    /**
     * Creates a new instance of the Erc721Transfers class from a JSON object.
     * @param json The JSON object representing the Erc721Transfers.
     * @returns A new instance of the Erc721Transfers class.
     */
    static fromJson(json) {
        return new Erc721Transfers(json.from, json.to, json.contractAddress, json.tokenId, json.name, json.symbol);
    }
}
exports.Erc721Transfers = Erc721Transfers;
